import {
    adminPendingTxDelete,
    adminPendingTxSearch
} from "@/shared/api/bankService";
import {
    FetchState,
} from "@/shared/types";
import {
    AdminPendingTx,
    AdminPendingTxSearchRequest,
    PendingTxState
} from "../types";
import { defineStore } from "pinia";
import _ from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";

const defaultState: PendingTxState = {
    accountName: "",
    fetchState: FetchState.Uninitialized,
    pendingTxs: []
};

export const usePendingTxStore = defineStore("pendingTx", {
    state: (): PendingTxState => (_.cloneDeep(defaultState)),
    getters: {
        canSearch: state => state.fetchState !== FetchState.Loading,
        hasAccountName: state => !!state.accountName && state.accountName.length > 0,
        txs: state => state.pendingTxs
    },
    actions: {
        setAccountName (accountName: string) {
            this.accountName = accountName;
        },
        setFetchState (newFetchState: FetchState) {
            this.fetchState = newFetchState;
        },
        setPendingTxs (newPendingTxs: AdminPendingTx[]) {
            this.pendingTxs = newPendingTxs;
        },
        setTxDisabled (tx: AdminPendingTx) {
            const txFound = this.pendingTxs.indexOf(tx);

            if (txFound === -1) {
                return;
            }

            tx.isDeleted = true;
            this.pendingTxs = [ ...this.pendingTxs ];
        },
        delete (tx: AdminPendingTx) {
            if (this.fetchState === FetchState.Loading) {
                return;
            }

            this.setFetchState(FetchState.Loading);
            return adminPendingTxDelete(tx.bankPendingTransactionId).then(response => {
                const data = response.data;

                if (data.errorMessage) {
                    const notifierStore = useNotifierStore();
                    notifierStore.setDanger(data.errorMessage);
                    return;
                }

                this.setTxDisabled(tx);
            }).finally(() => this.setFetchState(FetchState.Loaded));
        },
        search (request: AdminPendingTxSearchRequest) {
            if (this.fetchState === FetchState.Loading) {
                return;
            }

            this.setAccountName("");
            this.setFetchState(FetchState.Loading);
            return adminPendingTxSearch(request).then(response => {
                const data = response.data;

                if (data.errorMessage) {
                    const notifierStore = useNotifierStore();
                    notifierStore.setDanger(data.errorMessage);
                    return;
                }

                this.setAccountName(data.accountName);
                this.setPendingTxs(data.pendingTxs);
            }).finally(() => this.setFetchState(FetchState.Loaded));
        }
    }
});